// JOBE-0106 follow-up: SideRail — right-column container for the
// Project Home page (`/projects/{urn}`). Composes three blocks per
// the spec's §Scope item 13:
//
//   1. Dependents — projects that this project anchors (`inProject`).
//      The spec's target query is `inboundRelations.partOf=<urn>`;
//      the BFF allowlist (entities_list.go) does not yet accept
//      `inboundRelations.<pred>` keys, so v1 issues the closest
//      BFF-supported equivalent (`type=project&inProject=<urn>`) and
//      empties cleanly on 400 / cedar-deny / network failure.
//      Re-open when the entities-list allowlist widens.
//
//   2. Provenance trace — UI stub awaiting JOBE-0055.9. No fetch.
//
//   3. Settings — at-a-glance: status + dept chip + "created N days
//      ago". Click → `?tab=settings`.
//
// PR #766 shipped the page without the rail; this PR restores the
// missing two blocks (Dependents + Settings-glance) and lands the
// Provenance block as a Preview-pilled stub awaiting JOBE-0055.9.

import React from 'react';

import { DependentsBlock } from './DependentsBlock.jsx';
import { ProvenanceBlock } from './ProvenanceBlock.jsx';
import { SettingsGlanceBlock } from './SettingsGlanceBlock.jsx';

export function SideRail({ projectURN, detail, onOpenSettings }) {
  return (
    <aside
      className="project-home-rail"
      aria-label="Project side rail"
      data-testid="project-home-rail"
    >
      <DependentsBlock projectURN={projectURN} />
      <ProvenanceBlock />
      <SettingsGlanceBlock detail={detail} onOpenSettings={onOpenSettings} />
    </aside>
  );
}
